import React from 'react';


// STEP 1: createContext(<預設值>)
export const LayoutContext = React.createContext({
    //圖層更新
    layers: [],
    updateLayers: (updatingLayers) => {},
});